// src/pages/Game/kids/KidsGame.jsx
import ClassicGame from "../classic/ClassicGame";
export default ClassicGame;
